<template lang="pug">
.delivery-data-icon(v-if="hasDeliveries")
  button.delivery-data-icon__btn(type="button" @click.stop="showModal = true")
    span.material-symbols-outlined(:style="iconStyle") local_shipping

  DeliveryDataModal(
    :show="showModal"
    :record="recordData"
    @close="showModal = false"
    @updated="onUpdated"
    @refresh="onRefresh"
  )
</template>

<script>
import DeliveryDataModal from '@/components/elements/delivery/DeliveryDataModal.vue'
import { latestDeliveryDiffersFromRecord, recordHasDeliveries } from '@/helpers/deliveryMass'

export default {
  name: 'DeliveryDataIcon',

  components: { DeliveryDataModal },

  props: {
    record: {
      type: Object,
      default: null
    },
    iconSize: {
      type: String,
      default: '1.75rem'
    }
  },

  data () {
    return {
      showModal: false
    }
  },

  computed: {
    recordData () {
      return this.record
    },

    hasDeliveries () {
      return recordHasDeliveries(this.recordData)
    },

    isOutdated () {
      return latestDeliveryDiffersFromRecord(this.recordData)
    },

    iconStyle () {
      return {
        color: this.isOutdated ? 'var(--color-red)' : 'var(--color-font-principal, #363636)',
        fontSize: this.iconSize,
        opacity: 1
      }
    }
  },

  methods: {
    onUpdated () {
      this.$emit('updated')
    },

    onRefresh () {
      this.$emit('refresh')
      this.showModal = false
    }
  }
}
</script>

<style lang="stylus" scoped>
.delivery-data-icon__btn
  border none
  background none
  padding 0
  margin 0
  cursor pointer
  display flex
  align-items center
  justify-content flex-start
  -webkit-tap-highlight-color transparent
  touch-action manipulation

  &:active
    opacity .7
</style>



// WEBPACK FOOTER //
// src/components/elements/delivery/DeliveryDataIcon.vue